import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DateFormats } from "../common/Constants";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export interface IDateService {
  formatToLocalTime(date: Date): string;
  formatWithoutTimezone(date: Date): string;
  formatWithoutTime(date: string): string;
}

const DateService = (): IDateService => {
  return {
    formatToLocalTime(date: Date) {
      return dayjs(date).format(DateFormats.DATETIME_LOCAL);
    },
    formatWithoutTimezone(date: Date) {
      return dayjs(date).utc().format(DateFormats.DATETIME_LOCAL);
    },
    formatWithoutTime(date: string) {
      return dayjs(date, DateFormats.BASIC_DATETIME, true).format(
        DateFormats.BASIC_DATE
      );
    }
  };
};

export { DateService };
